import { NgModule } from '@angular/core';
import {PreloadAllModules, RouterModule, Routes} from '@angular/router';
import {GridComponent} from './grid.component';
import {GridLogsComponent} from './grid-logs/grid-logs.component';
import {GridProductionComponent} from './grid-production/grid-production.component';
import {GridHistoryComponent} from './grid-history/grid-history.component';
import {GridDuplicatesComponent} from './grid-duplicates/grid-duplicates.component';
import {GridDeleteProductsComponent} from './grid-delete-products/grid-delete-products.component';
import {GridAiComponent} from './grid-ai/grid-ai.component';
import {GridAiTreeComponent} from "./grid-ai-tree/grid-ai-tree.component";
import {GridFineTuningComponent} from './grid-fine-tuning/grid-fine-tuning.component';
import {GridCollectionsComponent} from "./grid-collections/grid-collections.component";
import { GridAiTagsComponent } from '../components/grid-ai-tags/grid-ai-tags.component';

const routes: Routes = [
  {
    path: '',
    component: GridComponent
  },
  {
    path: 'logs',
    component: GridLogsComponent
  },
  {
    path: 'production',
    component: GridProductionComponent
  },
  {
    path: 'history',
    component: GridHistoryComponent
  },
  {
    path: 'duplicates',
    component: GridDuplicatesComponent
  },
  {
    path: 'delete',
    component: GridDeleteProductsComponent
  },
  {
    path: 'ai',
    component: GridFineTuningComponent
    // component: GridAiComponent
  },
  {
    path: 'collections',
    component: GridCollectionsComponent
  },
  {
    path: 'ai/tree',
    component: GridAiTreeComponent
  },
  {
    path: 'ai/tags',
    component: GridAiTagsComponent,
  },
  {
    path: 'ai/fine-tuning',
    component: GridFineTuningComponent
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class GridRoutingModule { }
